import { MergedSamplePoint } from 'types/models/samplePoint';
import SamplePointStatistic, { MergedSamplePointStatistic, SamplePointStatisticWithAggregates } from 'types/models/samplePointsStatistic';
import getOriginalSamplePointIdsFromMergedSamplePoint from 'utils/associated-sample-points/get-original-sample-point-ids-from-merged-sample-point';
import { mapSoilAggregates, mergeSoilSamplePointStatistics } from 'utils/associated-sample-points/merge-soil-moisture-temperature';
import { assertIsSamplePointStatisticWithAggregates } from 'utils/SamplePointStatistics/assert-is-with-aggregates';

export function getMergedStatisticForSoil(
  allStatistics: Record<number, SamplePointStatistic>,
  mainSamplePoint: MergedSamplePoint
): MergedSamplePointStatistic & SamplePointStatisticWithAggregates {
  const [mainSamplePointId, hiddenSamplePointId] = getOriginalSamplePointIdsFromMergedSamplePoint(mainSamplePoint);

  const moisture = allStatistics[mainSamplePointId];

  assertIsSamplePointStatisticWithAggregates(moisture);

  const moistureWithMappedAggregates = {
    ...moisture,
    aggregates: mapSoilAggregates(moisture.aggregates, 'Moisture')
  };

  if (hiddenSamplePointId) {
    const temperature = allStatistics[hiddenSamplePointId];
    try {
      assertIsSamplePointStatisticWithAggregates(temperature);
    } catch (error) {
      return moistureWithMappedAggregates;
    }

    return mergeSoilSamplePointStatistics(moisture, temperature);
  }

  return moistureWithMappedAggregates;
}
